class UrlConstants {
    static privacy = 'https://www.pathpilot.ai/legal-pages/privacy-policy';
    static terms = 'https://www.pathpilot.ai/legal-pages/terms-of-service';
}

export default UrlConstants